import { Styles } from 'shared/types';

export const GridItem: Styles = { display: 'flex', flexDirection: 'column' };

export const TitleButtonIcon: Styles = { fontSize: 32 };

export const Button: Styles = { color: 'black' };

export const ButtonArrow: Styles = { height: 12, color: 'rgba(0, 0, 0, 0.54)' };
